import * as React from 'react';
import classNames from 'classnames';
import Spinner, { SpinnerProps } from '../../atoms/Spinner';

import styles from './SpinnerOverlay.module.scss';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  size?: SpinnerProps['size'];
  /**
   * Cover the whole viewport (`position: fixed`) instead of the nearest
   * positioned ancestor. Useful for full-page loaders that must stay in place
   * while the page scrolls.
   */
  fixed?: boolean;
}

const SpinnerOverlay: React.FunctionComponent<Props> = ({
  className,
  size,
  fixed = false,
  ...htmlElementProps
}) => (
  <div
    className={classNames(styles.overlay, { [styles.fixed]: fixed }, className)}
    {...htmlElementProps}
  >
    <Spinner size={size} />
  </div>
);

export default SpinnerOverlay;
